import React from 'react';
import {AccessControlIndicator, defineAccessControlledResource, GroupAccessRule} from '@igp/shared/access-control';
import {ReferralLinkButton, useUserProfileDetails} from '@igp/shared/features/user-profile';
import {RealtimeUpdatesMode} from '@igp/shared/redux/realtime';

import {groups, withAccessCheck} from '@access-control';

export const referalLinkButtonResource = defineAccessControlledResource({
    name: 'ReferalLinkButtonResource',
    rules: new GroupAccessRule([groups.agentsGroup]),
});

type ReferralLinkButtonProps = {
    uid: string;
    disabled?: boolean;
};

function ReferralLinkButtonOuter(props: ReferralLinkButtonProps) {
    const {item} = useUserProfileDetails({
        viewType: 'ReferralLink',
        id: props.uid,
        fields: ['referral.personal_referral_code'],
        realtimeMode: RealtimeUpdatesMode.Silent,
    });

    return <ReferralLinkButton {...props} personalReferralCode={item?.referral?.personal_referral_code} />;
}

export default withAccessCheck(ReferralLinkButtonOuter, referalLinkButtonResource, AccessControlIndicator.Disabled);
